module.exports = __webpack_public_path__ + "static/media/sc4.2daa6576.svg";